import { Component, Injector, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Toast } from 'primeng/toast';
import { SelectGoodDialogComponent } from 'src/app/components/select-good-dialog/select-good-dialog.component';
import { TrackingService } from 'src/app/services/tracking/tracking.service';
import { UserService } from 'src/app/services/user/user.service';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';
import { SearchLogClickHistoryService } from 'src/app/services/search-log-click-history.service';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./tracking.component.scss']
})

export class TrackingeComponent extends BaseFormComponentComponent implements OnInit {

  container: string;
  shipmentNo: string;
  operation: string;
  loading: boolean = true;
  processLoading: boolean = false;
  showDialog: boolean = false;
  trackingData: any = null;
  fileUrl: string;
  safeUrl: SafeUrl = null;
  notResult: boolean = false;
  selectedInvoice = null;
  currencyOptions = [{label: 'USD', value: 'amount1'}, {label: 'EUR', value: 'amount2'}];
  selectedCurrency = "amount1"
  safeHtml: any;
  msgPreviewMode: boolean = false;

  showCargoDetail = false;
  openedPriceGroups: { [key: number]: boolean } = {};

  loaderOptions: AnimationOptions = {path: '/assets/lottie/tracking-load.json'};
  laoderStyles: Partial<CSSStyleDeclaration> = {width: '100%',margin: '0 auto',};

  togglePriceGroup(index: number): void {
  this.openedPriceGroups[index] = !this.openedPriceGroups[index];

    if (this.openedPriceGroups[index]) {
      this.createClickHistory('FINANCE', 'RATESINFO');
    }
  }


  constructor(protected injector: Injector, public config: DynamicDialogConfig, private renderer: Renderer2, private router: Router, private trackingService: TrackingService, private sanitizer: DomSanitizer, private userService: UserService,public dialogService: DialogService,private searchLogHistoryService: SearchLogClickHistoryService) {
    super(injector)
  }


  async ngOnInit() {
    this.container = this.config.data.searchText || null;
    this.shipmentNo = this.config.data.shipmentNo || null;
    this.operation = this.config.data.operation.code.toLowerCase() || null;
    this.getTrackingData();
     this.openedPriceGroups[0] = true;

  }

  private setInitialCargoDetailState(): void {
  this.showCargoDetail =
    this.operation === 'sea' && this.trackingData?.operationType === 'F';
}

  get insuranceDocuments(): any[] {
  return this.trackingData?.documents || [];
}

get operationDateRows() {
      const ref = this.trackingData?.referenceNo || '';

      const transportType = this.trackingData?.transportType;

      // Hava
      // 1. Liman – Liman Yüklemeler
      // Ön Taşıma Tarihi gösterilmemeli
      // Son Taşıma Tarihi gösterilmemeli
      // Yük Teslim Tarihi gösterilmemeli
      // 2. Adres – Liman Yüklemeler
      // Son Taşıma Tarihi gösterilmemeli
      // Yük Teslim Tarihi gösterilmemeli
      // 3. Liman – Adres Yüklemeler
      // Ön Taşıma Tarihi gösterilmemeli

      // Deniz
      // 1. Liman – Liman (Port to Port) Yüklemeler
      // Ön Taşıma bilgisi gösterilmemeli
      // Gümrük İşlemleri Bitişi gösterilmemeli
      // Son Taşıma Tarihi gösterilmemeli
      // Boş Konteyner Dönüş Tarihi gösterilmemeli
      // 2. Adres – Liman (Door to Port) Yüklemeler
      // Gümrük İşlemleri Bitişi gösterilmemeli
      // Son Taşıma Tarihi gösterilmemeli
      // Boş Konteyner Dönüş Tarihi gösterilmemeli
      // 3. Liman – Adres (Port to Door) Yüklemeler
      // Ön Taşıma Tarihi alanı gösterilmemeli

      const isAirImport = ref.includes('.AI.'); //Hava İthalat
      const isAirExport = ref.includes('.AE.'); //Hava İhracat
      let isSeaImportF = false;
      let isSeaImportL = false;
      if (this.trackingData?.operationType=="F"  && ref.includes('.SI.')){
         isSeaImportF = true; //Deniz İthalat -FCL
      }

      if (this.trackingData?.operationType=="P" && ref.includes('.SI.')){
         isSeaImportL = true; //Deniz İthalat -LCL
      }
      
      const isSeaExport = ref.includes('.SE.'); //Deniz İhracat

      console.log(`isAirImport = ${isAirImport}, isAirExport = ${isAirExport}, isSeaImportF = ${isSeaImportF}, isSeaImportL = ${isSeaImportL}, isSeaExport = ${isSeaExport}`);
      console.log('transportType=>' , transportType);
      const rows: Array<{ label: string; planned?: string | null; actual?: string | null }> = [];

        if (isAirImport ) {
           //hazır olma tarihi
          rows.push({
            label: 'readyDateTT',
            planned:null ,
            actual: this.trackingData?.readyDate
          });
          //ön taşıma
           if ( transportType !== 'ATA' && transportType !=='ATD') {
            rows.push({
              label: 'loadDateLabel',
              planned: this.trackingData?.loadEstDate,
              actual: this.trackingData?.loadDate
            });
          }
          //ambara giriş 
          rows.push({
          label: 'warehouseEntryDate',
          planned: null,
          actual: this.trackingData?.warehouseEntryDate
          });
          //kalkış / Varış
          rows.push({
            label: 'departureDate',
            planned: this.trackingData?.etd,
            actual: this.trackingData?.departureDate1
          });
          rows.push({
            label: 'arrivalDate',
            planned: this.trackingData?.arrivalEstDate1,
            actual: this.trackingData?.arrivalDate1
          });
          //ordino hazır oluş
          rows.push({
            label: 'ordDate',
            planned: null,
            actual: this.trackingData?.ordDate
          });
          //ordino teslim
          rows.push({
              label: 'deliveryOrderReleased',
              planned: null,
              actual: this.trackingData?.drtbDate
            });
          //boşaltma tarihi
            if (transportType !== 'DTA' && transportType !== 'ATA') {
              rows.push({
                label: 'finalDeliveryDate',
                planned: this.trackingData?.unloadEstDate,
                actual: this.trackingData?.unloadDate
              });
            }


          //yük teslim
          if (transportType !== 'DTA' && transportType !== 'ATA') {
            rows.push({
              label: 'podDate',
              planned: this.trackingData?.requestedDeliveryDate,
              actual: this.trackingData?.podDate
            });
          }
        }

        if (isAirExport ) {
            //hazır olma tarihi
            rows.push({
              label: 'readyDateTT',
              planned:null ,
              actual: this.trackingData?.readyDate
            });
            //Mal Kabul Opsiyon Tarihi
            rows.push({
              label: 'goodAcceptDate',
              planned:null ,
              actual: this.trackingData?.goodAcceptDate
            });
            //Evrak Kabul Opsiyon Tarihi
            rows.push({
              label: 'documentAcceptDate',
              planned:null ,
              actual: this.trackingData?.documentAcceptDate
            });
           
            //Depo Giriş Tarihinin Girilmesi
            rows.push({
            label: 'warehouseEntryDate',
            planned: null,
            actual: this.trackingData?.warehouseEntryDate
            });
             //Gerçekleşen Yükleme Tarihi
            rows.push({
              label: 'loadDateLabel',
              planned: this.trackingData?.loadEstDate,
              actual: this.trackingData?.loadDate
            });
            //Ambar Giriş Tarihi
            rows.push({
              label: 'storeHouseInDate',
              planned: null,
              actual: this.trackingData?.storeHouseInDate
            });

            //Gümrük İşlemleri Bitiş Tarihi
            rows.push({
              label: 'customCleranceCompleted',
              planned: null,
              actual: this.trackingData?.customCleranceCompleted
            });

              //kalkış / Varış
            rows.push({
              label: 'departureDate',
              planned: this.trackingData?.estimatedFromDate,
              actual: this.trackingData?.fromDate
            });
            rows.push({
              label: 'arrivalDate',
              planned: this.trackingData?. estimatedToDate,
              actual: this.trackingData?.toDate
            });
  
             //yük teslim
              if (transportType !== 'DTA' && transportType !== 'ATA') {
                rows.push({
                  label: 'podDate',
                  planned: null,
                  actual: this.trackingData?.documentDeliveryDate
                });
              }

          }

          if (isSeaImportF ) {
           //hazır olma tarihi
          rows.push({
            label: 'readyDateTT',
            planned:null ,
            actual: this.trackingData?.readyDate
          });
          //ön taşıma
          if ( transportType !== 'ATA' && transportType !== 'ATD'){
            rows.push({
            label: 'loadDateLabel',
            planned: this.trackingData?.loadEstDate,
            actual: this.trackingData?.loadDate
          });
          }
          
          //ambara giriş 
          rows.push({
          label: 'warehouseEntryDate',
          planned: this.trackingData?.warehouseEstEntryDate,
          actual: this.trackingData?.wareHouseRealEntryDate
          });
          //kalkış / Varış
          rows.push({
            label: 'departureDate',
            planned: this.trackingData?.etd,
            actual: this.trackingData?.atd
          });
          //Çıkış İhbarı Gönderildi
          rows.push({
            label: 'hblDate',
            planned: null,
            actual: this.trackingData?.hblDate
          });
          //Varış
          rows.push({
            label: 'arrivalDate',
            planned: this.trackingData?.eta,
            actual: this.trackingData?.ata
          });
      
          //ordino hazır oluş
          rows.push({
            label: 'ordDate',
            planned: null,
            actual: this.trackingData?.requestedDeliveryDate
          });
          //ordino teslim
          rows.push({
              label: 'deliveryOrderReleased',
              planned: null,
              actual: this.trackingData?.documentDeliveryDate
            });
          //İthalat Gümrükleme
            if ( transportType !== 'ATA' &&  transportType !=='DTA'){
              rows.push({
              label: 'customCleranceCompleted',
              planned: null,
              actual: this.trackingData?.customCleranceCompleted
              });
            }
          //boşaltma tarihi
           if ( transportType !== 'ATA' &&  transportType !=='DTA'){
              rows.push({
                label: 'finalDeliveryDate',
                planned: this.trackingData?.unloadEstDate,
                actual: this.trackingData?.unloadDate
              });
            }
           //yük teslim
          rows.push({
            label: 'podDate',
            planned: this.trackingData?.requestedDeliveryDate,
            actual: this.trackingData?.podDate
          });
           //boş kenteyner tarihi
            if ( transportType !== 'ATA' &&  transportType !=='DTA'){
              rows.push({
                label: 'ecrDate',
                planned: null,
                actual: this.trackingData?.ecrDate
              });
            }
               
        }

        if (isSeaImportL ) {
           //hazır olma tarihi
          rows.push({
            label: 'readyDateTT',
            planned:null ,
            actual: this.trackingData?.readyDate
          });
          //ön taşıma
          if ( transportType !== 'ATA' && transportType !== 'ATD'){
            rows.push({
              label: 'loadDateLabel',
              planned: this.trackingData?.loadEstDate,
              actual: this.trackingData?.loadDate
            });
          }
          //ambara giriş 
          rows.push({
          label: 'warehouseEntryDate',
          planned: this.trackingData?.warehouseEstEntryDate,
          actual: this.trackingData?.wareHouseRealEntryDate
          });
          //kalkış / Varış
          rows.push({
            label: 'departureDate',
            planned: this.trackingData?.etd,
            actual: this.trackingData?.atd
          });
          //Çıkış İhbarı Gönderildi
          rows.push({
            label: 'hblDate',
            planned: null,
            actual: this.trackingData?.hblDate
          });
          //Varış
          rows.push({
            label: 'arrivalDate',
            planned: this.trackingData?.eta,
            actual: this.trackingData?.ata
          });
     
          //ordino hazır oluş
          rows.push({
            label: 'ordDate',
            planned: null,
            actual: this.trackingData?.requestedDeliveryDate
          });
          //ordino teslim
          rows.push({
              label: 'deliveryOrderReleased',
              planned: null,
              actual: this.trackingData?.documentDeliveryDate
            });
          //İthalat Gümrükleme
            if ( transportType !== 'ATA' && transportType !=='DTA'){
              rows.push({
              label: 'customCleranceCompleted',
              planned: null,
              actual: this.trackingData?.customCleranceCompleted
              });
            }
          //boşaltma tarihi
           if ( transportType !== 'ATA' &&  transportType !=='DTA'){
              rows.push({
                label: 'finalDeliveryDate',
                planned: this.trackingData?.unloadEstDate,
                actual: this.trackingData?.unloadDate
              });
            }
           //yük teslim
          rows.push({
            label: 'podDate',
            planned: this.trackingData?.requestedDeliveryDate,
            actual: this.trackingData?.podDate
          });               
        }


     
        if (isSeaExport ) {
            //hazır olma tarihi
            rows.push({
              label: 'readyDateTT',
              planned:null ,
              actual: this.trackingData?.readyDate
            });

          //Beyanname Cut-Off
            rows.push({
              label: 'bdCutoffDate',
              planned:null ,
              actual: this.trackingData?.bdCutoffDate
            });

            //VGM Cut-Off
            rows.push({
              label: 'vgmCutoffDate',
              planned:null ,
              actual: this.trackingData?.vgmCutoffDate
            });

            //Talimat Cut-Off
            rows.push({
              label: 'tdCutoffDate',
              planned:null ,
              actual: this.trackingData?.tdCutoffDate
            });
          
            //ön taşıma
            if ( transportType !== 'ATA' && transportType !== 'ATD'){
                rows.push({
                  label: 'loadDateLabel',
                  planned: this.trackingData?.loadEstDate,
                  actual: this.trackingData?.loadDate
                });
              }
            
          
            //İthalat Gümrükleme
              if ( transportType !== 'ATA' && transportType !=='DTA'){
                rows.push({
                label: 'customCleranceCompleted',
                planned: null,
                actual: this.trackingData?.customCleranceCompleted
                });
              }
            //kalkış / Varış
            rows.push({
              label: 'departureDate',
              planned: this.trackingData?.etd,
              actual: this.trackingData?.atd
            });
              //Çıkış İhbarı Gönderildi
            rows.push({
              label: 'hblDate',
              planned: null,
              actual: this.trackingData?.hblDate
            });
            //Varış
            rows.push({
              label: 'arrivalDate',
              planned: this.trackingData?.eta,
              actual: this.trackingData?.ata
            });
            //son taşıma tarihi tarihi
             if ( transportType !== 'ATA' &&  transportType !=='DTA'){
              rows.push({
                label: 'finalDeliveryDate',
                planned: this.trackingData?.unloadEstDate,
                actual: this.trackingData?.unloadDate
              });
            }
            //yük teslim
            rows.push({
              label: 'podDate',
              planned: this.trackingData?.requestedDeliveryDate,
              actual: this.trackingData?.podDate
            });  
            //boş kenteyner tarihi
             if ( transportType !== 'ATA' &&  transportType !=='DTA'){
              rows.push({
                label: 'ecrDate',
                planned: null,
                actual: this.trackingData?.ecrDate
              });    
            }         
          }

      //return rows.filter(row => row.planned || row.actual || row.planned === null || row.actual === null);
      return rows;
    }

  private async fetchTrackingByRef(refOrHawb: string) {
    this.trackingData = await this.trackingService.tracking(refOrHawb, this.operation).toPromise();
    this.notResult = !this.trackingData || Object.keys(this.trackingData).length === 0;

     if (!this.notResult) {
        this.setInitialCargoDetailState();
      }

     if (!this.notResult) {
        this.setInitialCargoDetailState();
      }
  }

  async getTrackingData() {
    this.loading = true;

    try {
      if (this.shipmentNo) {
        this.trackingData = await this.trackingService.trackingShipment(this.shipmentNo, this.operation).toPromise();
        this.notResult = !this.trackingData || Object.keys(this.trackingData).length === 0;

           if (!this.notResult) {
            this.setInitialCargoDetailState();
          }
          

           if (!this.notResult) {
            this.setInitialCargoDetailState();
          }
          
        this.loading = false;
        return;
      }

      if (this.container) {
        const matches = await this.trackingService.searchGoods(this.container, this.operation).toPromise();
        if (!matches || matches.length === 0) {
          this.notResult = true;
          this.loading = false;
          return;
        }

        if (matches.length === 1) {
          const key = matches[0].hawb || matches[0].referenceNo || this.container;
          await this.fetchTrackingByRef(key);

          if (!this.notResult) {
            this.setInitialCargoDetailState();
          }


          if (!this.notResult) {
            this.setInitialCargoDetailState();
          }

          this.loading = false;
          return;
        }
        this.loading = false;
        this.openPickDialog(matches);
      }
    } catch (e) {
      this.loading = false;
      this.notResult = true;
    }
  }

  openPickDialog(items: any[]) {
    const ref: DynamicDialogRef = this.dialogService.open(SelectGoodDialogComponent, {
      header: this.translation.currentLang === 'tr' ? 'Kayıt Seçin' : 'Select a record',
      width: '800px',
      data: { 
        items,
        operation: this.operation
      }
    });

    ref.onClose.subscribe(async (picked: any) => {
      if (!picked) return;
      this.loading = true;
      try {
        const key = picked.hawb || picked.referenceNo || this.container;
        await this.fetchTrackingByRef(key);
      } finally {
        this.loading = false;
      }
    });
  }

  

  // async onViewFile(document: any) {
  //   this.processLoading = true;
  //   try {
  //     if (document.contentType === 'application/vnd.ms-outlook' || document.contentType === 'message/rfc822') {
  //       const html = await this.userService.getDocByteForTrackAndTrackingAsHtml(document.reference, document.contentType, document.name).toPromise();
  //       this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(html);
    
  //       this.msgPreviewMode = true;
  //     } else {
  //       this.processLoading = true;
  //       try {
  //         const file = await this.userService.getDocByteForTrackAndTracking(document.reference, document.contentType, document.name).toPromise();
  //         this.fileUrl = URL.createObjectURL(file);
  //         this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);

  //         this.showDialog = true;
  //         this.processLoading = false;
  //         this.msgPreviewMode = false;
  //       } catch {
  //         this.processLoading = false;
  //       }
  //     }
  
  //     this.showDialog = true;
  //     this.processLoading = false;
  //   } catch (e) {
  //     this.processLoading = false;
  //     this.showMessage("warn","Dosya gösterilemedi.");
  //   }
  // }
  async onViewFile(document: any, source: 'QUICKINFO' | 'STATUS' = 'QUICKINFO') {
    const docName = document?.name || null;

    if (source === 'STATUS') {
      this.createClickHistory('STATUS', docName);
    } else {
      this.createClickHistory(
        'QUICKINFO',
        docName ? `DOCUMENTS(${docName})` : 'DOCUMENTS'
      );
    }

    this.processLoading = true;

    try {
      if (
        document.contentType === 'application/vnd.ms-outlook' ||
        document.contentType === 'message/rfc822'
      ) {
        const html = await this.userService
          .getDocByteForTrackAndTrackingAsHtml(
            document.reference,
            document.contentType,
            document.name
          )
          .toPromise();

        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(html);
        this.msgPreviewMode = true;
      } else {
        try {
          const file = await this.userService
            .getDocByteForTrackAndTracking(
              document.reference,
              document.contentType,
              document.name
            )
            .toPromise();

          this.fileUrl = URL.createObjectURL(file);
          this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);

          this.showDialog = true;
          this.msgPreviewMode = false;
        } catch {
          this.processLoading = false;
        }
      }

      this.showDialog = true;
      this.processLoading = false;
    } catch (e) {
      this.processLoading = false;
      this.showMessage('warn', 'Dosya gösterilemedi.');
    }
  }

  getFileExtension(mimeType) {
    const mimeTypes = {
      'application/pdf': 'pdf',
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      'application/vnd.ms-excel': 'xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'application/vnd.ms-powerpoint': 'ppt',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
      'image/jpeg': 'jpg',
      'image/png': 'png',
      'image/gif': 'gif',
      'image/bmp': 'bmp',
      'image/webp': 'webp',
      'text/plain': 'txt',
      'text/html': 'html',
      'application/json': 'json',
      'application/zip': 'zip',
      'application/x-rar-compressed': 'rar',
      'audio/mpeg': 'mp3',
      'audio/wav': 'wav',
      'video/mp4': 'mp4',
      'video/x-msvideo': 'avi',
      'application/vnd.ms-outlook': 'msg',
      'message/rfc822': 'eml'
    };
    return mimeTypes[mimeType] || 'unknown'; 
  }
  avaiablePreview(mineType) {
    return ['jpg', 'gif', 'png', 'pdf', 'jpeg', 'txt', 'msg', 'eml'].includes(this.getFileExtension(mineType));
  }

  async downloadFile(document: any) {
    this.processLoading = true;
    try {
            const response = await this.userService.getDigitalFile(document.reference, document.contentType, document.name).toPromise();

      const blob = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
  
      const a = this.renderer.createElement('a');
      this.renderer.setAttribute(a, 'href', url);

      let ext =  this.getFileExtension(document.contentType);
      
      this.renderer.setAttribute(a, 'download', `${document.name}.${ext}`); 
      a.click();
  
      // Bellekteki URL referansını kaldır
      window.URL.revokeObjectURL(url);
  
      this.processLoading = false;
    } catch {
      this.processLoading = false;
    }
  
  }

  downloadInvoice(document: any) {
  
    const blob = new Blob([  this._base64ToArrayBuffer(document.invoice)], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);

    const a = this.renderer.createElement('a');
    this.renderer.setAttribute(a, 'href', url);

    let ext =  this.getFileExtension(document.contentType);
    
    this.renderer.setAttribute(a, 'download', `${document.reference}.pdf`); 
    a.click();

    // Bellekteki URL referansını kaldır
    window.URL.revokeObjectURL(url);
  }


  _base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  clearbase64STR(dataURI) {
    const BASE64_MARKER = ';base64,';
    const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    return dataURI.substring(base64Index);
  }

  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

  getGrandAmountTotal(items): number {
    return items.reduce((sum, item) => sum + item[this.selectedCurrency], 0);
  }

  onCurrencyChanged(value: string) {
    if (value === 'amount2') {
      this.showMessage("warn", "Genel toplam Euro olarak hesaplanmıştır.");
    }
  }
  
  createClickHistory(costType: string, viewType: string): void {
    const model = new SearchLogClickHistoryModel();

    model.searchLogId = this.config?.data?.searchLogId || this.trackingData?.searchLogId || null;
    model.productName = this.getTrackingProductName();
    model.productId = this.config?.data?.operation?.id || null;
    model.uuid = this.trackingData?.uuid || null;

    model.costType = costType;
    model.viewType = viewType;

    model.info = this.trackingData?.referenceNo ;

    this.searchLogHistoryService.create(model).toPromise();
  }

  private getTrackingProductName(): string {
    const op = (this.operation || '').toUpperCase();

    if (op === 'AIR') return 'AIR-T&T';
    if (op === 'SEA') return 'SEA-T&T';

    return `${op}-T&T`;
  }

  onOperationTabChange(event: any): void {
    switch (event.index) {
      case 0:
        this.createClickHistory('QUICKINFO', 'DATES');
        break;
      case 1:
        this.createClickHistory('QUICKINFO', 'DOCUMENTS');
        break;
      case 2:
        this.createClickHistory('QUICKINFO', 'PRE-ON');
        break;
    }
  }

  onFinanceTabChange(event: any): void {
    switch (event.index) {
      case 0:
        this.createClickHistory('FINANCE', 'RATESINFO');
        break;
      case 1:
        this.createClickHistory('FINANCE', 'INVOICES');
        break;
    }
  }

  toggleCargoDetail(): void {
    this.showCargoDetail = !this.showCargoDetail;

    if (this.showCargoDetail) {
      this.createClickHistory('PACKAGES', 'DETAILS');
    }
  }

      get documentSlots(): any[] {
      const scenario = this.getDocumentScenario();

      const slots = this.getRequiredDocumentSlots(scenario);

      console.log ("slots" , slots );

      return slots.map(slot => ({
        ...slot,
        document: this.findDocumentByCode(slot.code)
      }));
    }

    private getDocumentScenario(): string {
      const ref = this.trackingData?.referenceNo || '';
      const isSeaExport = ref.includes('.SE.');
      const isSeaImport = ref.includes('.SI.');
      const isAirImport = ref.includes('.AI.');


      const isAgentSide = this.trackingData?.isAgentSide === true;

      console.log('Scenario Debug', {
  isAgentSide,
  isSeaExport,
  isSeaImport,
  isAirImport,
  referenceNo: this.trackingData?.referenceNo
});

      if (isSeaExport && !isAgentSide) return 'SEA_EXPORT_CUSTOMER';
      if (isSeaExport && isAgentSide) return 'SEA_EXPORT_AGENT';

      if (isSeaImport && !isAgentSide) return 'SEA_IMPORT_CUSTOMER';
      if (isSeaImport && isAgentSide) return 'SEA_IMPORT_AGENT';

      if (isAirImport && !isAgentSide) return 'AIR_IMPORT_CUSTOMER';

 

      return 'DEFAULT';
    }

    private getRequiredDocumentSlots(scenario: string): Array<{ label: string; code: string }> {
      const map = {
        SEA_EXPORT_CUSTOMER: [
          { label: 'Deniz Teklif PDF', code: 'Deniz Teklif PDF' },
          { label: 'Konşimento Talimatı', code: 'KONSIMENTO TALIMATI' },
          { label: 'VGM Tartım Sonucu', code: 'VGM TARTIM SONUCU' },
          { label: 'Draft MBL', code: 'DRAFT HBL' },
          { label: 'Final MBL', code: 'FINAL MBL' },
          { label: 'Beyanname', code: 'BEYANNAME' }
        ],

        SEA_EXPORT_AGENT: [
          { label: 'Deniz Teklif PDF', code: 'Deniz Teklif PDF' },
          { label: 'Konşimento Talimatı', code: 'KONSIMENTO TALIMATI' },
          { label: 'VGM Tartım Sonucu', code: 'VGM TARTIM SONUCU' },
          { label: 'Draft HBL', code: 'DRAFT HBL' },
          { label: 'Final HBL', code: 'FINAL MBL' },
          { label: 'Beyanname', code: 'BEYANNAME' }
        ],

        SEA_IMPORT_CUSTOMER: [
          { label: 'Deniz Teklif PDF', code: 'Deniz Teklif PDF' },
          { label: 'Draft HBL', code: 'DRAFT HBL' },
          { label: 'Final HBL', code: 'FINAL MBL' }
        ],

        SEA_IMPORT_AGENT: [],

        AIR_IMPORT_CUSTOMER: [
          { label: 'Hava Teklif PDF', code: 'Hava Teklif PDF' },
          { label: 'FHAWB', code: 'FHAWB' },
          { label: 'Draft HAWB', code: 'DHAWB' }
        ],

        DEFAULT: []
      };

      return map[scenario] || [];
    }

    private findDocumentByCode(code: string): any {
      const documents = this.trackingData?.documents || [];

      console.log ("documents" , documents);

      return documents.find(doc => {
        const docCode = (
          doc?.code ||
          doc?.documentCode ||
          doc?.type ||
          doc?.documentType ||
          doc?.name ||
          ''
        ).toString().toLowerCase();

        return docCode.includes(code.toLowerCase());
      });
    }

  

 
}
